<template>
    <div class="bg-white px-3">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" @sort-change='sortChange' :height="heights"
                ref="configurationTable">
                <el-table-column prop="title" label="商品名称" show-overflow-tooltip> </el-table-column>
                <el-table-column sortable='custom' prop="goods_click" label="浏览量" show-overflow-tooltip>
                </el-table-column>
                <el-table-column sortable='custom' prop="goods_vis" label="访客数" show-overflow-tooltip>
                </el-table-column>
                <el-table-column sortable='custom' prop="payuser_count" label="兑换人数" show-overflow-tooltip>
                </el-table-column>
                <el-table-column sortable='custom' prop="pay_price" label="兑换积分" show-overflow-tooltip>
                </el-table-column>
                <el-table-column sortable='custom' prop="pay_per" label="兑换转化率" show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <!-- <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div> -->
        </div>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    docname: '',
                    doc_options: [],
                    sexname: '',
                    bzname: '',
                    bz_options: [],
                    type: '',
                    type_options: [{
                            id: 1,
                            name: '已收货'
                        },
                        {
                            id: 2,
                            name: '退款中'
                        },
                    ],
                },
                invformData: {
                    invtime: '',
                    invtype: '',
                    type_options: [{
                            id: 1,
                            name: '已收货'
                        },
                        {
                            id: 2,
                            name: '退款中'
                        },
                    ],
                },

                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,

                invlistdialogs: false,
                invlisttableData: [],
                invloading: false,
                invlistcurrentPage: 1,
                invlistpagesize: 15,
                invlistcount: 0,
                invuser_id: 0,

                ord: 1,
                ind: 3

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            this.getDate6()
            // that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/report/seckillGoodsReport", {
                        // page: that.currentPage,
                        // page_count: that.pagesize,
                        start_time: this.formData.time ? this.formData.time[0] : '',
                        end_time: this.formData.time ? this.formData.time[1] : '',
                        sort_type: this.ord,
                        sort_field: this.ind,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                    })
                    .catch(error => {
                        console.log(error.response);
                    })
            },
            sortChange({
                column,
                prop,
                order
            }) {
                this.ord = order == 'ascending' ? 2 : 1
                if (prop == 'goods_click') {
                    this.ind = 1
                }
                if (prop == 'goods_vis') {
                    this.ind = 2
                }
                if (prop == 'payuser_count') {
                    this.ind = 3
                }
                if (prop == 'pay_price') {
                    this.ind = 4
                }
                if (prop == 'pay_per') {
                    this.ind = 5
                }
                this.currentPage = 1
                this.search()
            },

            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                that.formData.time = [start, end]
                that.begin()
            },


        },

    };
</script>

<style lang="scss" scoped>
    .inv_user {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>